import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PlayerCard } from "./PlayerCard";
import { Font } from "./TextElement";
import { ScreenSize, useScreenSize } from "../util/MediaQueries";
import { PlayerText } from "./PlayerText";
import { useContact3DPlayerRecords } from "../../../game/contact3d/replicatedObjects/Contact3DPlayerRecords";
import { getPlayerPrefix } from "../../../core/util/PlayerUtils";
export const PlayerTag = (props) => {
    const isAbsolute = props.absolutePositioning !== undefined;
    const absTop = (isAbsolute && props.absolutePositioning.top) || 'auto';
    const absLeft = (isAbsolute && props.absolutePositioning.left) || 'auto';
    const absBottom = (isAbsolute && props.absolutePositioning.bottom) || 'auto';
    const absRight = (isAbsolute && props.absolutePositioning.right) || 'auto';
    const positionProps = {
        top: absTop,
        left: absLeft,
        right: absRight,
        bottom: absBottom,
    };
    const players = useContact3DPlayerRecords();
    const username = players.getPlayerUsername(props.playerId);
    const prefix = getPlayerPrefix(username);
    const screenSize = useScreenSize();
    const fontSize = screenSize === ScreenSize.Large ? 16 : 12;
    const padding = screenSize === ScreenSize.Large ? '10px' : '6px';
    const playerCardElement = _jsx(PlayerCard, Object.assign({ padding: padding }, props, { children: _jsx(PlayerText, { playerId: props.playerId, text: prefix, font: Font.Inter, fontSize: fontSize }) }));
    const verticallyCenter = isAbsolute && props.verticallyCentered;
    const verticallyCenterContainer = ({ children }) => verticallyCenter ?
        _jsx("div", { style: Object.assign(Object.assign({ position: 'absolute' }, positionProps), { top: '50%' }), children: children }) : _jsx(_Fragment, { children: children });
    return (_jsxs(_Fragment, { children: [isAbsolute && verticallyCenterContainer({
                children: _jsx("div", { style: Object.assign({ position: verticallyCenter ? 'relative' : 'absolute' }, (verticallyCenter ? { marginTop: '-50%' } : positionProps)), children: playerCardElement })
            }), !isAbsolute && playerCardElement] }));
};
//# sourceMappingURL=PlayerTag.js.map